import type { ICellRendererComp, ICellRendererParams } from "ag-grid-community";

export class MasterDetailCellRenderer implements ICellRendererComp {
  detailCellGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.detailCellGui = document.createElement("div");
    this.detailCellGui.setAttribute("role", "gridcell");
    this.detailCellGui.setAttribute("class", "h-full w-full");

    this.detailCellGui.setAttribute(
      "style",
      `padding-left: 44px; background-color: #f5f5f5; overflow: auto; text-wrap: break-word; white-space: normal;`,
    );

    const summary = this.getSummary(params);

    this.detailCellGui.innerHTML = `<p class="q-pa-xs"><strong>${params.data.summaryLabel}</strong>: ${summary}</p>`;
  }

  getGui() {
    return this.detailCellGui;
  }

  refresh(params: ICellRendererParams) {
    const summary = this.getSummary(params);
    this.detailCellGui.innerHTML = `<p class="q-pa-xs"><strong>${params.data.summaryLabel}</strong>: ${summary}</p>`;

    return true;
  }

  getSummary(params) {
    const numberOfSummaryCharacters = Math.floor(params.columnApi.columnModel.scrollWidth / 4);
    let summary = params.data.summary;

    if (summary?.length > numberOfSummaryCharacters) {
      summary = summary.substring(0, numberOfSummaryCharacters) + "...";
    }
    return summary;
  }
}
